import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/quotationService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchQuotations = createAsyncThunk("quotations/fetchAll", async (params) => {
  const res = await svc.getQuotations(params);
  return res.data;
});

export const createQuotationThunk = createAsyncThunk("quotations/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createQuotation(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to save quotation."));
  }
});

export const updateQuotationThunk = createAsyncThunk("quotations/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateQuotation(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update quotation."));
  }
});

export const deleteQuotationThunk = createAsyncThunk("quotations/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteQuotation(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete quotation."));
  }
});

const quotationSlice = createSlice({
  name: "quotations",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuotations.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchQuotations.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchQuotations.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createQuotationThunk.fulfilled, (state, action) => { state.list.unshift(action.payload); })
      .addCase(updateQuotationThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((q) => q.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteQuotationThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((q) => q.id !== action.payload);
      });
  },
});

export default quotationSlice.reducer;
